import { ReactElement, ReactNode } from 'react'
import { Row, Col, ColProps, Pagination, Placeholder } from 'react-bootstrap';
import NewsItem, { NewsItemPlaceholder, NewsPost } from '@components/news/item'
import { each, repeat } from '@utils/objects'

type NewsListProps = {
  posts: NewsPost[],
  loaded?: boolean,
  size?: ColProps['md'],
  pagination?: {
    page: number,
    totalPages: number,
    onChangePage: (newPage: number) => void,
  },
  children?: ReactNode
} & ReactElement['props'] & React.HTMLAttributes<HTMLElement>;

export default function NewsList({ posts, pagination, loaded = true, size = 12, children = [], ...props }: NewsListProps): ReactElement {
  props.className = props.className ? `${props.className} news-list` : 'news-list';

  const placeholders = (typeof size === 'number' ? Math.floor(12 / size) : 1);

  return (
    <div {...props}>
      {(! loaded && posts.length === 0) && (
        <Row>
          { repeat(placeholders, (item) => (
            <Col xs={12} md={size} key={item}>
              <NewsItemPlaceholder/>
              <NewsItemPlaceholder/>
            </Col>
          ) ) }
        </Row>
      )}
      {(loaded && posts.length > 0) && (
        <Row>
          {each<NewsPost, ReactElement>(posts, (post: NewsPost) => (
            <Col xs={12} md={size} key={`new-list-item-${post.id}`}>
              <NewsItem post={post} />
            </Col>
          ), true ) }
        </Row>
      )}
      {(pagination && pagination.totalPages > 1) && (
        <Row className="mt-3">
          <Col>
            <Pagination className="news-list-pagination">
              { repeat(pagination.totalPages, (page) => <Pagination.Item key={page} active={page === pagination.page} onClick={() => pagination.onChangePage(page)}>{page}</Pagination.Item>, 1 ) }
            </Pagination>
          </Col>
        </Row>
      )}
      {children}
    </div>
  );
}
